/* tslint:disable */
/* eslint-disable */
export enum RoleEnum {
  EducationProfessionals = 'EducationProfessionals',
  HealthProfessionals = 'HealthProfessionals',
  LegalSocialandWelfareProfessionals = 'LegalSocialandWelfareProfessionals',
  BusinessFinanceandMarketingProfessionals = 'BusinessFinanceandMarketingProfessionals',
  ArtsandMediaAndSportsProfessionals = 'ArtsandMediaAndSportsProfessionals',
  EngineeringIctAndTechnicalProfessionals = 'EngineeringIctAndTechnicalProfessionals',
  ScienceAndResearchProfessionals = 'ScienceAndResearchProfessionals',
  PublicSectorGovernmentRoles = 'PublicSectorGovernmentRoles',
  ConstructionAndMiningWorkers = 'ConstructionAndMiningWorkers',
  AgricultureHorticultureAndAnimalWorkers = 'AgricultureHorticultureAndAnimalWorkers',
  CleaningAndMaintenanceWorkers = 'CleaningAndMaintenanceWorkers',
  ClericalAndAdministrativeWorkers = 'ClericalAndAdministrativeWorkers',
  AutomotiveAndElectrotechnologyTradesWorkers = 'AutomotiveAndElectrotechnologyTradesWorkers',
  HospitalityAndFoodServicesWorkers = 'HospitalityAndFoodServicesWorkers',
  RealEstateAndPropertyServices = 'RealEstateAndPropertyServices',
  TransportAndLogisticsWorkers = 'TransportAndLogisticsWorkers',
  ManufacturingAndProductionWorkers = 'ManufacturingAndProductionWorkers',
  SecurityAndProtectiveServices = 'SecurityAndProtectiveServices',
  EmergencyServices = 'EmergencyServices',
  ManagersAndExecutives = 'ManagersAndExecutives',
  RetailAndSalesWorkers = 'RetailAndSalesWorkers'
}
